const EnterBar = () => import(/* webpackChunkName:"chunk-actbar" */ '../views/P5_Activitys/ActEnterBar/index.vue')

const BeerAct = () => import(/* webpackChunkName:"chunk-beeract" */ '../views/P5_Activitys/BeerCollect')

const CallMotivation = () => import(/* webpackChunkName:"chunk-callmotivation" */ '../views/P5_Activitys/CallMotivation/index.vue')
const CallMotivationRules = () => import(/* webpackChunkName:"chunk-callmotivation" */ '../views/P5_Activitys/CallMotivation/rules.vue')

// 动态页面容器
const DyPage = () => import(/* webpackChunkName:"chunk-dypage" */ '../views/P5_Activitys/DyPage/index.vue')

const Incentive = () => import(/* webpackChunkName:"chunk-incentive" */ '../views/P5_Activitys/Incentive/index.vue')
const IncentiveForNew = () => import(/* webpackChunkName:"chunk-incentivefornew" */ '../views/P5_Activitys/IncentiveForNew/index.vue')

const InviteEarn = () => import(/* webpackChunkName:"chunk-inviteearn" */ '../views/P5_Activitys/InviteEarn/index.vue')

const Liveness = () => import(/* webpackChunkName:"chunk-liveness" */ '../views/P5_Activitys/Liveness/index.vue')
const LivenessRules = () => import(/* webpackChunkName:"chunk-liveness" */ '../views/P5_Activitys/Liveness/rules.vue')

const MatchingToPay = () => import(/* webpackChunkName:"chunk-matchingtopay" */ '../views/P5_Activitys/MatchingToPay/index.vue')

const NewguyWheelPan = () => import(/* webpackChunkName:"chunk-NewguyWheelPan" */ '../views/P5_Activitys/NewguyWheelPan/index.vue')
const NewguyWheelPanRules = () => import(/* webpackChunkName:"chunk-NewguyWheelPan" */ '../views/P5_Activitys/NewguyWheelPan/rules.vue')

const NineDotNinetyNine = () => import(/* webpackChunkName:"chunk-NineDotNinetyNine" */ '../views/P5_Activitys/NineDotNinetyNine/index.vue')

const NineteenDotNinetyNine = () => import(/* webpackChunkName:"chunk-NineteenDotNinetyNine" */ '../views/P5_Activitys/NineteenDotNinetyNine/index.vue')

const PrivateCallIncome = () => import(/* webpackChunkName:"chunk-privatecall" */ '../views/P5_Activitys/PrivateCallIncome')

const RechargeAfterFirst = () => import(/* webpackChunkName:"chunk-rechargeAfterFirst" */ '../views/P5_Activitys/RechargeAfterFirst/index.vue')

const RechargeFirst = () => import(/* webpackChunkName:"chunk-rechargefirst" */ '../views/P5_Activitys/RechargeFirst/index.vue')

const RechargeLowSmall = () => import(/* webpackChunkName:"chunk-rechargeLowSmall" */ '../views/P5_Activitys/RechargeLowSmall/index.vue')

const RechargeMidR = () => import(/* webpackChunkName:"chunk-rechargeMidR" */ '../views/P5_Activitys/RechargeRUser/midR.vue')
const RechargeTopR = () => import(/* webpackChunkName:"chunk-rechargeTopR" */ '../views/P5_Activitys/RechargeRUser/topR.vue')

const Repurchase = () => import(/* webpackChunkName:"chunk-repurchase" */ '../views/P5_Activitys/Repurchase/index.vue')

const SayHi = () => import(/* webpackChunkName:"chunk-sayhi" */ '../views/P5_Activitys/SayHi/index.vue')

const SubAgentEvent = () => import(/* webpackChunkName:"chunk-subagentevent" */ '../views/P5_Activitys/SubAgentEvent/index.vue')

const WorldCupMainFemale = () => import(/* webpackChunkName:"chunk-worldcup" */ '../views/P5_Activitys/WorldCup/actFemaleMain.vue')
const WorldCupRankFemale = () => import(/* webpackChunkName:"chunk-worldcup" */ '../views/P5_Activitys/WorldCup/actFemaleRank.vue')
const WorldCupRulesFemale = () => import(/* webpackChunkName:"chunk-worldcup" */ '../views/P5_Activitys/WorldCup/actFemaleRules.vue')
const WorldCupMainMale = () => import(/* webpackChunkName:"chunk-worldcup" */ '../views/P5_Activitys/WorldCup/actMaleMain.vue')
const WorldCupRankMale = () => import(/* webpackChunkName:"chunk-worldcup" */ '../views/P5_Activitys/WorldCup/actMaleRank.vue')
const WorldCupRecordsMale = () => import(/* webpackChunkName:"chunk-worldcup" */ '../views/P5_Activitys/WorldCup/actMaleRecords.vue')
const WorldCupRulesMale = () => import(/* webpackChunkName:"chunk-worldcup" */ '../views/P5_Activitys/WorldCup/actMaleRules.vue')

const ActTemplateMainFemale = () => import(/* webpackChunkName:"chunk-acttemplate" */ '../views/P5_Activitys/ActTemplate/actFemaleMain.vue')
const ActTemplateRankFemale = () => import(/* webpackChunkName:"chunk-acttemplate" */ '../views/P5_Activitys/ActTemplate/actFemaleRank.vue')
const ActTemplateRulesFemale = () => import(/* webpackChunkName:"chunk-acttemplate" */ '../views/P5_Activitys/ActTemplate/actFemaleRules.vue')
const ActTemplateMainMale = () => import(/* webpackChunkName:"chunk-acttemplate" */ '../views/P5_Activitys/ActTemplate/actMaleMain.vue')
const ActTemplateRecordsMale = () => import(/* webpackChunkName:"chunk-acttemplate" */ '../views/P5_Activitys/ActTemplate/actMaleRecords.vue')
const ActTemplateRulesMale = () => import(/* webpackChunkName:"chunk-acttemplate" */ '../views/P5_Activitys/ActTemplate/actMaleRules.vue')

const routes = [
  // 运营位
  {
    path: '/act-enter', name: 'act-enter', component: EnterBar
  },
  // 啤酒收集节
  {
    path: '/beer-collect', name: 'beer-collect', component: BeerAct
  },
  // 男用户通话激励
  {
    path: '/call-motivation', name: 'call-motivation', component: CallMotivation
  },
  {
    path: '/call-motivation-rules', name: 'call-motivation-rules', component: CallMotivationRules
  },

  // 自定义图片页面
  {
    path: '/dy-page/:customPageId', name: 'dy-page', component: DyPage
  },
  // 激励活动
  {
    path: '/incentive-act', name: 'incentive-act', component: Incentive
  },
  // 新用户激励活动
  {
    path: '/incentive-fornew', name: 'incentive-fornew', component: IncentiveForNew
  },
  // 分享裂变
  {
    path: '/invite-earn', name: 'invite-earn', component: InviteEarn
  },
  // 升级奖励
  {
    path: '/liveness', name: 'liveness', component: Liveness
  },
  {
    path: '/liveness-rules', name: 'liveness-rules', component: LivenessRules
  },
  // match
  {
    path: '/matching-to-pay', name: 'matching-to-pay', component: MatchingToPay
  },
  // 新用户转盘
  {
    path: '/newguy-wheel-pan', name: 'newguy-wheel-pan', component: NewguyWheelPan
  },
  {
    path: '/newguy-wheel-pan-rules', name: 'newguy-wheel-pan-rules', component: NewguyWheelPanRules
  },
  // 充值活动9.99
  {
    path: '/recharge-ninepointninety', name: 'nine-dot-ninetynine', component: NineDotNinetyNine
  },
  // 充值活动19.99
  {
    path: '/nineteen-ninety_nine', name: 'nineteen-dot-ninetynine', component: NineteenDotNinetyNine
  },
  // 主播限时付费电话补贴
  {
    path: '/private-call-income', name: 'private-call-income', component: PrivateCallIncome
  },
  // 充值-次充
  {
    path: '/recharge-afterfirst', name: 'recharge-afterfirst', component: RechargeAfterFirst
  },
  // 充值-首充
  {
    path: '/recharge-first', name: 'recharge-first', component: RechargeFirst
  },
  // 低频小额用户充值
  {
    path: '/recharge-low-small', name: 'recharge-low-small', component: RechargeLowSmall
  },
  // 中小R用户充值
  {
    path: '/recharge-mid-r', name: 'recharge-mid-r', component: RechargeMidR
  },
  // 大R用户充值
  {
    path: '/recharge-top-r', name: 'recharge-top-r', component: RechargeTopR
  },
  // 复购
  {
    path: '/repurchase', name: 'repurchase', component: Repurchase
  },
  // SayHi
  {
    path: '/say-hi', name: 'say-hi', component: SayHi
  },
  // 二级代理活动
  {
    path: '/sub-agent-event', name: 'sub-agent-event', component: SubAgentEvent
  },
  // 世界杯活动
  {
    path: '/worldcup-main-female', name: 'worldcup-main-female', component: WorldCupMainFemale
  },
  {
    path: '/worldcup-rank-female', name: 'worldcup-rank-female', component: WorldCupRankFemale
  },
  {
    path: '/worldcup-rules-female', name: 'worldcup-rules-female', component: WorldCupRulesFemale
  },
  {
    path: '/worldcup-main-male', name: 'worldcup-main-male', component: WorldCupMainMale
  },
  {
    path: '/worldcup-rank-male', name: 'worldcup-rank-male', component: WorldCupRankMale
  },
  {
    path: '/worldcup-records-male', name: 'worldcup-records-male', component: WorldCupRecordsMale
  },
  {
    path: '/worldcup-rules-male', name: 'worldcup-rules-male', component: WorldCupRulesMale
  },
  // 活动模板（女用户）
  {
    path: '/act-template-female-main', name: 'act-template-female-main', component: ActTemplateMainFemale
  },
  {
    path: '/act-template-female-rank', name: 'act-template-female-rank', component: ActTemplateRankFemale
  },
  {
    path: '/act-template-female-rules', name: 'act-template-female-rules', component: ActTemplateRulesFemale
  },
  // 活动模板（男用户）
  {
    path: '/act-template-male-main', name: 'act-template-male-main', component: ActTemplateMainMale
  },
  {
    path: '/act-template-male-records', name: 'act-template-male-records', component: ActTemplateRecordsMale
  },
  {
    path: '/act-template-male-rules', name: 'act-template-male-rules', component: ActTemplateRulesMale
  }
]
export default routes
